import './styles.scss'
import React from 'react'
import { useParams } from 'react-router-dom'

import AssistantView from './AssistantView'
import Nixi1Spinner from 'components/Nixi1Spinner'

const TabContent = ({ botHeader, setFaqToScroll, loading, errorMessage, getBotHeader }) => {
  const { assistantId } = useParams()

  return (
    <div className='tabs-content'>
      {loading ? (
        <Nixi1Spinner width={'25px'} height={'25px'} />
      ): (
        !errorMessage ? (
          assistantId === botHeader._id ? (
            <AssistantView 
              botHeader={botHeader} 
              setFaqToScroll={setFaqToScroll}   
              getBotHeader={getBotHeader}
            /> 
          ): null
        ) : (
          <p className='error-message'>{errorMessage}</p>
        )
      )}
    </div>
  )
}

export default TabContent
